module.exports = __webpack_public_path__ + "fonts/Averta-Bold.09f030a.woff";